import React from 'react'
import { Icon } from '@blueprintjs/core'
import { lang } from 'enablex/shared'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import style from '../style.scss'
import UserIcon from '~/icons/UserIcon'
import AndroidIcon from '~/icons/AndroidIcon'
import BrandingIcon from '~/icons/BrandingIcon'

const MenuItem = ({ text, icon, id, active, config }: any) => {
    return (
        <li id={id} key={id}>
            <a
                href='javascript:void(0)'
                className={cx({ [style.active]: active })}
                style={active ? { borderColor: config?.themeColor } : {}}
            >
                <Icon icon={icon} />
                <span style={active ? {color: config?.themeColor } : {color: '#333'}}>{text}</span>
            </a>
        </li>
    )
}

export const Menu = ({ config }) => {

    return <>
        <aside className={cx(style.sidebar, 'bp-sidebar')}>
            <ul className='nav'>
                <MenuItem
                    id="btn-menu-bots"
                    text={lang.tr('admin.sideMenu.bots')}
                    icon={<AndroidIcon width="32" height="32" color={config.themeColor || '#333'} />}
                    active={true}
                    config={config}
                />

                <MenuItem
                    id="btn-menu-users"
                    text={lang.tr('admin.sideMenu.collaborators')}
                    icon={<UserIcon width="32" height="32" color="#333" />}
                    active={false}
                    config={config}
                />

                <MenuItem
                    id="btn-menu-branding"
                    text={lang.tr('admin.sideMenu.branding')}
                    icon={<BrandingIcon width="32" height="32" color="#333" />}
                    active={false}
                    config={config}
                />
            </ul>
        </aside>
    </>
}
